import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';

import LangSelect from '../../../../../shared/lang/select';
import InputField from '../../../../../shared/form-elements/input';
import SelectField from '../../../../../shared/form-elements/select/field';
import SelectCountriesField from '../../../../../shared/form-elements/select-countries/field';
import CheckboxField from '../../../../../shared/form-elements/checkbox';

const DragHandle = SortableHandle(() => <div className="drag-handle" />);

const isRocket = process.env.CPA_ENV === 'rocket';

const SortableItem = SortableElement(props => {
	const field = props.fields.get(props.originalIndex);
	return (
		<div className="landing-ui-form__element" key={props.originalIndex} style={{display: 'flex'}}>
			<div className='position-date' style={getDateStyle(field)}>
				{moment(field.created_at).format('DD.MM.YY')}
			</div>
			<Field name="id" component="input" type="hidden" />
			<div
				className={`position-link ${!props.shouldTranslate && 'drag-handle-active' || ''}`}
				style={{display: 'flex', maxHeight: '40px'}}
			>
				{ !props.shouldTranslate &&  <DragHandle />}
				<Field
					name={`${props.parentName}.domain`}
					disabled={props.shouldTranslate}
					placeholder={props.intl('Domain')}
					showLabel={false}
					component={InputField} />
			</div>
			<div className="position-title">
				<Field
					name={`${props.parentName}.title`}
					placeholder={props.intl('Title')}
					showLabel={false}
					component={InputField} />
			</div>
			<div className="position-select">
				<Field
					name={`${props.parentName}.affiliate_ids`}
					searchable={true}
					disabled={props.shouldTranslate}
					placeholder={ props.intl('Affiliates') }
					multi={true}
					component={SelectField}
					showLabel={false}
					options={props.affiliatesLookup}  />
			</div>
			<div className="position-select position-select--label">
				<Field
					name={`${props.parentName}.labels`}
					searchable={false}
					disabled={props.shouldTranslate}
					placeholder={ props.intl('Labels') }
					multi={true}
					component={SelectField}
					showLabel={false}
					options={props.offerPromoLabelsOptions}  />
			</div>
			<div className="position-lang">
				<Field
					name={`${props.parentName}.languages`}
					disabled={props.shouldTranslate}
					component={LangSelectField}
					defaultLang={props.defaultLang}
					showLabel={false}
					langs={props.langs} />
			</div>
			<div className="position-default-country">
				<Field
					name={`${props.parentName}.default_country_id`}
					placeholder={props.intl('')}
					component={ SelectCountriesField }
					multi={false}
					disabled={props.shouldTranslate ||
					(!isRocket && props.title && props.title !== 'Add landing')}
					showLabel={false}
					searchable={false}
					options={props.locationsLookups}
				/>
			</div>
			{!isRocket && (
				<div className="position-restricted">
					<Field
						name={`${props.parentName}.is_restricted`}
						disabled={props.shouldTranslate}
						normalize={v => !!v}
						showLabel={false}
						component={CheckboxField}
					/>
				</div>
			)}
			{ process.env.CPA_ENV === 'everad' &&
				<div className="position-mt_approved">
					<Field
						name={`${props.parentName}.is_mgid`}
						disabled={props.shouldTranslate}
						normalize={v => !!v}
						showLabel={false}
						component={CheckboxField}
					/>
				</div>
			}
			{ !props.shouldTranslate && props.can('edit') && (
				<div className="position-action">
					<a
						className='view-icon'
						target='_blank'
						href={'http://' + field.domain}
						style={{
							pointerEvents: field.domain ? undefined : 'none'
						}}
					/>
					<span
						className="delete"
						onClick={() => {
							if (field.id && props.fields.name) {
								props.remove({id: field.id, type: props.fields.name});
							} else {
								props.fields.remove(props.originalIndex);
							}
						} }/>
				</div>
			) }
		</div>
	);
});

function getDateStyle(field) {
	if (moment(field.created_at).isAfter(moment().subtract('6', 'months'))) {
		return { color: 'gray' };
	}
	if (field.metadata) {
		if (field.metadata.relevance_for_last_12_months === false) {
			return { color: 'red' };
		}
		if (field.metadata.relevance_for_last_6_months === 'lead') {
			return { color: 'green' };
		}
		if (field.metadata.relevance_for_last_6_months === false) {
			return { color: 'orange' };
		}
	}
}

const LangSelectField = props => {
	const { touched, error } = props.meta;
	return (
		<div className='form-element-select'>
			<LangSelect {...props.input} langs={props.langs} defaultLang={props.defaultLang} disabled={props.disabled} />
			{touched && error && <span className="error">{error}</span>}
		</div>
	);
};

LangSelectField.propTypes = {
	meta: PropTypes.object,
	input: PropTypes.object,
	langs: PropTypes.array,
	defaultLang: PropTypes.string,
	disabled: PropTypes.bool
};

export default SortableItem;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/landings/sortable/item.js